import { RouteAnimationShared } from './../../../utils/route-animation-shared';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { baseUrl, phoneNumberUrl } from 'src/app/global-variables';
import { MainShared } from 'src/app/presentation/general/shared/main-shared';
import { NgxIndexedDBService } from 'ngx-indexed-db';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { RevokeResponse } from 'src/app/core/model/authentication-response-model';

@Injectable({
  providedIn: 'root',
})
export class LogoutService {
  constructor(
    private router: Router,
    private mainShared: MainShared,
    private dbService: NgxIndexedDBService,
    private http: HttpClient,
    private routeAnimationShared: RouteAnimationShared
  ) {}

  async logout(forceLogout?: boolean) {
    if (localStorage.getItem('token') && forceLogout) {
      const authorization = 'Bearer ' + localStorage.getItem('token');
      const headerDict = {
        Authorization: authorization,
        'x-deviceType': 'pwa',
        'x-versionCode': '81',
      };
      await this.http
        .get<RevokeResponse>(baseUrl + 'api/v2/users/revoke', {
          headers: new HttpHeaders(headerDict),
        })
        .toPromise()
        .then((res) => {
          return res;
        })
        .catch(() => {
          return new RevokeResponse(false);
        });
    }

    await this.dbService.clear('diets');
    await this.dbService.clear('newDiets');
    await this.dbService.clear('waterlogs');
    await this.dbService.clear('weightlogs');
    await this.dbService.clear('foods');
    await this.dbService.clear('foodLogs');
    await this.dbService.clear('personalFood');
    await this.dbService.clear('personalPackage');
    await this.dbService.clear('exerciseLogs');
    await this.dbService.clear('cookingbook');

    let tutorial = '';
    if (localStorage.getItem('tutorial')) {
      tutorial = localStorage.getItem('tutorial');
    }
    let intro = '';
    if (localStorage.getItem('no-need-intro')) {
      intro = localStorage.getItem('no-need-intro');
    }
    localStorage.clear();
    if (tutorial !== '') {
      localStorage.setItem('tutorial', tutorial);
    }
    if (intro !== '') {
      localStorage.setItem('no-need-intro', intro);
    }
    this.mainShared.currentTab = 1;
    this.routeAnimationShared.showRouteAnimation();
    this.router.navigate([phoneNumberUrl]);
    setTimeout(() => {
      window.location.reload();
    }, 1000);
  }
}
